import { Slice } from "store/utils/slice";
import type { AgentWithHealth } from "./client";
import type { KeyRotation } from "legacy/api/SigningKeyRotationApi";
import type { EntitiesStateWithMeta } from "store/utils/types";

export type AgentMeta = {
  organizationId?: string;
  keyRotations?: KeyRotation[];
};

export type AgentState = EntitiesStateWithMeta<AgentWithHealth, AgentMeta>;

export default new Slice<AgentState>("agents", {
  entities: {},
  loading: {},
  errors: {},
  meta: {},
});
